export default "__VITE_ASSET__D_jtQ26T__"